import React, { useContext, useEffect, useRef } from "react";
import { GridLoader } from "../../rcsgrid/createGridTools";
import { DefaultDialogContentProps } from "./DialogAcctools";
import { formEdit } from "../../Tools/Tools";
import { createGrid, createRecordSource } from "../../rcsgrid/rcsgrid";
import clsx from "clsx";
import dialogStyles from "./Components/dialogStyles.module.css";
import { SmetaModalsButtonsContext } from "../../Tools/modalManager";

export default function DialogCert({ props }: DefaultDialogContentProps) {
  const { RequestID: requestId, from, Buttons: buttons, hiddenButton, func } = props;

  const gridpanelRef = useRef(null);
  const [mainGrid, setMainGrid] = React.useState<{ grid: createGrid; source: createRecordSource }>();

  const setButtons = useContext(SmetaModalsButtonsContext);

  useEffect(() => {
    if (hiddenButton) return;
    const modalButtons: { [key: number]: { label: string; onClick: () => void } } = {};
    if (!buttons || Number(buttons) & 1) {
      modalButtons[1] = { label: "Выбрать", onClick: onSelect };
    }
    setButtons?.(modalButtons);
  }, [setButtons, mainGrid]);

  /**
   * Загружает и записывает таблицу в состояние
   */
  const loadGrid = async () => {
    setMainGrid(await GridLoader(gridpanelRef.current, props));
  };

  /**
   * Инициализация таблицы
   */
  const firstGridLoad = () => {
    loadGrid();
  };
  useEffect(firstGridLoad, []);

  /**
   * Отправляет выбранную запись в tokenProcessing
   */
  const onSelect = async () => {
    if (requestId) {
      await formEdit("1", func, { RecordIndex: mainGrid?.source.activeRecord }, requestId, from);
    }
  };

  /**
   * Отправляет данные об отмене в tokenProcessing
   */
  const onCancel = async () => {
    await formEdit("0", func, {}, requestId, from);
  };

  return (
    <div className={clsx(dialogStyles.mainDialogBlock)} style={{ position: "relative", height: "100%" }}>
      <div className={clsx(dialogStyles.fullDialogFlexContainer)}>
        <div
          id={`rcgrid_panel`}
          ref={gridpanelRef}
          style={{
            position: "relative",
            height: "100%",
            width: "100%",
          }}
        ></div>
      </div>
    </div>
  );
}
